import { useEffect, useState } from "react";
import api from "./api";

// Verrou d'édition partagé : un seul utilisateur à la fois sur un document.
export const acquireLock = async (kind, id) => {
  try {
    await api.post("/locks", { kind, id });
    return { ok: true };
  } catch (e) {
    if (e.response?.status === 409) return { ok: false, message: e.response.data.detail };
    return { ok: true };
  }
};

export const releaseLock = (kind, id) => api.delete(`/locks/${kind}/${id}`).catch(() => {});

// Prend le verrou au montage, le renouvelle toutes les 30 s, le libère au démontage.
export const useDocLock = (kind, id, enabled = true) => {
  const [lockedBy, setLockedBy] = useState(null);
  const [checked, setChecked] = useState(!enabled || !id);
  useEffect(() => {
    if (!enabled || !id) { setLockedBy(null); setChecked(true); return; }
    let active = true;
    let timer = null;
    const run = async () => {
      const r = await acquireLock(kind, id);
      if (!active) return;
      setLockedBy(r.ok ? null : r.message);
      setChecked(true);
      timer = setTimeout(run, 30000);
    };
    run();
    return () => { active = false; clearTimeout(timer); releaseLock(kind, id); };
  }, [kind, id, enabled]);
  return { lockedBy, checked };
};
